import { render, staticRenderFns } from "./Gateway.vue?vue&type=template&id=3a8777c3&scoped=true&"
import script from "./Gateway.vue?vue&type=script&lang=js&"
export * from "./Gateway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8777c3",
  null
  
)

export default component.exports